import { ApolloLink } from 'apollo-link';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
// import { withClientState } from 'apollo-link-state';
import { baseUrl } from './globals';
// import { defaults, resolvers } from './apolloClientState';

const cache = new InMemoryCache();

const httpLink = new HttpLink({ uri: `${baseUrl}/graphql` });
const authLink = setContext((_, { headers }) => {
  const apiToken = localStorage.getItem('userApiToken');
  return {
    headers: {
      ...headers,
      authorization: apiToken ? `Bearer ${apiToken}` : '',
    },
  };
});
// const stateLink = withClientState({
//   cache,
//   resolvers,
//   defaults,
// });
const client = new ApolloClient({
  link: ApolloLink.from([
    // stateLink,
    authLink,
    httpLink,
  ]),
  cache,
});

// client.onResetStore(stateLink.writeDefaults);

export default client;



// WEBPACK FOOTER //
// ./src/utils/apolloClient.js